import { useRouter } from 'next/router';
import { getSystemIdFromChainAndAsset, getSystemIdSupportedChains } from 'utils/multichain';

export default () => {
  const router = useRouter()
  const hasSystemId = Boolean(router.query.systemId?.length);

  let systemId;

  if (hasSystemId) {
    const routeChain = router.query.systemId.toString();

    systemId = routeChain.includes(":") ? routeChain.split(":")[0] : routeChain
  } else {
    const routeChain = Array.isArray(router.query.chain)
      ? router.query.chain[0]
      : router.query.chain || '';
    const routeAssetTokenId = Array.isArray(router.query.assetId)
      ? router.query.assetId[0]
      : router.query.assetId || '';

    const routeAssetId = routeAssetTokenId.split(":")[0]

    systemId = getSystemIdFromChainAndAsset(routeChain, routeAssetId) || '';
  }

  const supportedSystemIdChains = getSystemIdSupportedChains(systemId);
  const DefaultChain = supportedSystemIdChains[0]

  return { supportedSystemIdChains, systemId, DefaultChain }
}
